 export const hotspots = [
    {
      id: 1,
      x: '32%',
      y: '30%',
      label: 'Navigation Tracking',
      firstLine: 'horizontal',
      direction: 'right',
      verticalDirection: 'down',
      horizontalLength: '100px',
      verticalLength: '170px',
      mobileHorizontalLength: '34px',
      mobileVerticalLength: '85px',
    },
    {
      id: 2,
      x: '19%',
      y: '40%',
      label: 'Interaction Hub',
      firstLine: 'vertical',
      direction: 'right',
      verticalDirection: 'down',
      horizontalLength: '50px',
      verticalLength: '130px',
      mobileHorizontalLength: '34px',
      mobileVerticalLength: '68px',
      
    },
    {
      id: 3,
      x: '32%',
      y: '46%',
      label: 'Translate',
      firstLine: 'vertical',
      direction: 'right',
      verticalDirection: 'down',
      horizontalLength: '50px',
      verticalLength: '100px',
      mobileHorizontalLength: '34px',
      mobileVerticalLength: '68px',
    },
    {
      id: 4,
      x: '72%',
      y: '40%',
      label: '3D Spatial Immersion',
      firstLine: 'vertical',
      direction: 'left',
      verticalDirection: 'down',
      horizontalLength: '50px',
      verticalLength: '130px',
      mobileHorizontalLength: '34px',
      mobileVerticalLength: '78px'
    },
    {
      id: 5,
      x: '81%',
      y: '20%',
      label: 'In-Context Object Tracking',
      firstLine: 'vertical',
      direction: 'left',
      verticalDirection: 'down',
      horizontalLength: '50px',
      verticalLength: '230px',
      mobileHorizontalLength: '34px',
      mobileVerticalLength: '104px',
    },
  ];